"use client";

// src/components/sections/NoticeBand/mockNoticeBand.ts
var mockNoticeBand = {
  firstAnchor: {
    icon: "info",
    label: "Condi\xE7\xF5es Gerais",
    href: "https://storage.googleapis.com/public-assets-stg/site/seguro-de-vida/SV_Condicoes_Gerais_Seguro_de_Vida_Stone.pdf"
  },
  secondAnchor: {
    icon: "bookOpen",
    label: "Manual do Segurado",
    href: "https://storage.googleapis.com/public-assets-stg/site/seguro-de-vida/SV_Manual_do_Segurado_-_Seguro_de_Vida_Stone.pdf"
  }
};

export {
  mockNoticeBand
};
